import React, { useEffect, useState } from 'react';
import './global-footer.scss';
import { Modal, Space } from 'antd';
import PrivacyStatementModal from './PrivacyStatementModal';
import IntroModal from './IntroModal';
import TermOfUseModal from './TermOfUseModal';
import ContactModal from './ContactModal';
import { useDispatch, useSelector } from 'react-redux';
import LoginModal from './LoginModal';
import { setLoginModal } from '../../redux/modalSlice';
import styled from 'styled-components';

export const MainTitle = styled.h3`
  text-align: center;
  color: #1a224d;
  font-weight: bold;
  background: white;
  margin-bottom: 0;
  padding-top: 20px;
  padding-bottom: 5px;
`;

const privacyStyle = {
  position: 'absolute',
  top: '75%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const introStyle = {
  position: 'absolute',
  top: '92%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const contactStyle = {
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const termStyle = {
  position: 'absolute',
  top: '67%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const loginStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '20px',
};

const GlobalFooter = () => {
  const dispatch = useDispatch();
  const loginModal = useSelector((state) => state.modal.loginModal);

  const [modal, setModal] = useState(false);
  const [style, setStyle] = useState(null);
  const [width, setWidth] = useState(700);

  useEffect(() => {
    // debug-console.log('[Use Effect] loginModal=', loginModal);
    if (loginModal) {
      setStyle(loginStyle);
      setModal('login');
      setWidth(590);
    } else {
      setModal(false);
    }
  }, [loginModal]);

  return (
    <footer id="footer">
      <div className="col-xs-12 col-sm-6 col-md-7">
        <Space className="link-a">
          <a
            onClick={() => {
              setStyle(introStyle);
              setWidth(900);
              setModal('intro');
            }}
          >
            Giới thiệu
          </a>

          {/* <a onClick={onViewContact}>Liên hệ</a> */}
          <a
            onClick={() => {
              setStyle(contactStyle);
              setWidth(700);
              setModal('contact');
            }}
          >
            Liên hệ
          </a>
          <a
            onClick={() => {
              setStyle(privacyStyle);
              setWidth(900);
              setModal('privacy');
            }}
          >
            Quyền riêng tư
          </a>

          <a
            onClick={() => {
              setStyle(termStyle);
              setWidth(900);
              setModal('term');
            }}
          >
            Điều khoản sử dụng
          </a>
        </Space>
      </div>

      <div className="col-xs-12 col-sm-6 col-md-5 copyright">
        <span className="span-footer">&copy;2025 Emil.vn</span>
        <span className="span-footer">Last updated {process.env.REACT_APP_LAST_UPDATED}</span>
      </div>

      <Modal
        open={modal}
        width={width}
        footer={null}
        closable={true}
        style={style}
        keyboard={true}
        onCancel={() => {
          setModal(false);
          dispatch(setLoginModal(false));
        }}
      >
        {modal === 'privacy' ? (
          <PrivacyStatementModal />
        ) : modal === 'intro' ? (
          <IntroModal />
        ) : modal === 'contact' ? (
          <ContactModal />
        ) : modal === 'term' ? (
          <TermOfUseModal />
        ) : modal === 'login' ? (
          <LoginModal />
        ) : null}
      </Modal>
      {/* <PrivacyStatementModal /> */}
    </footer>
  );
};

export default GlobalFooter;
